import styled from "styled-components";

export const Button = styled.button`
  font-family: "Work Sans";
  width: auto;
  display: flex;
  align-items: center;
  font-weight: 600;
  height: 1.875rem;
  border-radius: ${(props) =>
    props.border_radius ? props.border_radius : props.theme.borderRadius.sm};
  background: ${(props) => props.theme.buttonPalette[props.variant].background};
  color: ${(props) => props.theme.buttonPalette[props.variant].color};
  outline: none;
  padding: ${(props) => (props.padding ? props.padding : "")};
  border: none;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  span:first-child {
    padding-right: 0.438rem;
  }
`;

